<template>
  <q-form ref="editForm">
    <c-card title="기본정보" class="cardClassDetailForm">
      <template slot="card-button">
        <q-btn-group outline >
          <c-btn
            v-if="editable && !disabled"
            :url="saveUrl"
            :isSubmit="isSave"
            :param="educationInfo"
            :mappingType="saveType"
            label="저장"
            icon="save"
            @beforeAction="saveEducation"
            @btnCallback="saveCallback" 
          />
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-8 col-lg-4 col-xl-4">
          <c-text
            :afterIcon="disabled ? null :[
              { name: 'search', click: true, callbackName: 'searchEduMaster', color: 'teal' },
              { name: 'close', click: true, callbackName: 'removeEduMaster', color: 'red' }
            ]"
            :required="true" 
            :readonly="true"
            :editable="editable"
            label="교육과정"
            name="educationCourseName"
            @searchEduMaster="searchEduMaster"
            @removeEduMaster="removeEduMaster"
            v-model="educationInfo.educationCourseName">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-1 col-xl-1">
          <c-select
            :editable="editable"
            :disabled="true"
            type="edit"
            codeGroupCd="EDU_KIND_FST_CD"
            itemText="codeName"
            itemValue="code"
            name="educationKindCdLarge"
            label="교육종류1"
            v-model="educationInfo.educationKindCdLarge"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-1 col-xl-1">
          <c-select
            :disabled="true"
            :editable="editable"
            type="edit"
            codeGroupCd="EDU_KIND_SEC_CD"
            itemText="codeName"
            itemValue="code"
            name="educationKindCdSmall"
            label="교육종류2"
            v-model="educationInfo.educationKindCdSmall"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <c-text
            required
            :disabled="disabled"
            :editable="editable"
            label="교육명"
            name="educationName"
            v-model="educationInfo.educationName">
          </c-text>
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :disabled="disabled"
            :editable="editable"
            :required="true" 
            type="edit"
            codeGroupCd="EDU_CLASS_CD"
            itemText="codeName"
            itemValue="code"
            name="educationTypeCd"
            label="교육구분"
            v-model="educationInfo.educationTypeCd"
          ></c-select>
        </div> -->
        
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-1 col-xl-1">
          <c-checkbox
            :disabled="disabled"
            :editable="editable"
            :isFlag="true"
            label="기간,일"
            trueLabel="기간"
            falseLabel="일"
            name="educationRangeFlag"
            v-model="educationInfo.educationRangeFlag"
            @datachange="datachange"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-2 col-xl-2">
          <!-- 연간교육계획이 결재중인 경우 교육일시 수정 불가 -->
          <c-datepicker
            v-show="isDate"
            :required="isDate"
            :disabled="disabled || yearEduAppr"
            :editable="editable"
            label="교육기간"
            :range="true"
            type="date"
            name="educationDate"
            v-model="educationDate">
          </c-datepicker>
          <c-datepicker
            v-show="!isDate"
            :required="!isDate"
            :disabled="disabled || yearEduAppr"
            :editable="editable"
            label="교육일"
            type="date"
            name="educationDate2"
            v-model="educationDate2">
          </c-datepicker>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-2 col-xl-2">
          <c-datepicker
            :disabled="disabled"
            :editable="editable"
            type="time"
            label="교육시간"
            :range="true"
            :minuteStep="10"
            name="educationTime"
            v-model="educationTime"
            @datachange="eduTimeChange">
          </c-datepicker>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-1 col-xl-1">
          <c-text
            :afterIcon="disabled ? null :[
              { name: 'add', click: true, callbackName: 'sumEduTime', color: 'teal', tooltip: '(총 교육일) X (교육시간 차이)' },
            ]"
            :disabled="disabled"
            :editable="editable"
            label="총 교육시간"
            name="sumEducationTime"
            v-model="educationInfo.sumEducationTime"
            @sumEduTime="eduTimeChange">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
          <c-text
            :disabled="disabled"
            :editable="editable"
            label="교육장소"
            name="educationLocation"
            v-model="educationInfo.educationLocation">
          </c-text>
        </div>
        <!-- <div class="col-xs-4 col-sm-4 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :disabled="true"
            :editable="editable"
            type="time"
            :minuteStep="10"
            label="교육시간"
            name="educationTime"
            v-model="educationInfo.educationTime"
          />
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
          <c-select
            :disabled="true"
            type="edit"
            codeGroupCd="EDU_CYCLE_CD"
            itemText="codeName"
            itemValue="code"
            name="educationCycle"
            label="교육주기"
            v-model="educationInfo.educationCycle"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
          <c-radio
            :disabled="true"
            :editable="editable"
            type="edit"
            :comboItems="flagItems"
            itemText="codeName"
            itemValue="code"
            label="법정교육 여부"
            name="legalEducationFlag"
            v-model="educationInfo.legalEducationFlag">
          </c-radio>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
          <c-select
            :disabled="disabled"
            :editable="editable"
            type="edit"
            codeGroupCd="EDU_METHOD_CD"
            itemText="codeName"
            itemValue="code"
            name="educationMethodCd"
            label="교육방법"
            v-model="educationInfo.educationMethodCd"
          ></c-select>
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-text
            suffix="원"
            type="number"
            :editable="editable"
            :disabled="disabled"
            label="예상 계획"
            name="estimatedEducationExpenses"
            v-model="educationInfo.estimatedEducationExpenses">
          </c-text>
        </div> -->
        <div class="col-xs-12col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <c-textarea
            :disabled="true"
            :editable="editable"
            :rows="1"
            label="학습목적"
            name="educationPurpose"
            v-model="educationInfo.educationPurpose">
          </c-textarea>
        </div>
        <div class="col-xs-12col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <c-multi-select
            :disabled="true"
            :editable="editable"
            codeGroupCd="REGULATION_BILL_CD"
            itemText="codeName"
            itemValue="code"
            label="관련 법규"
            name="relationLaws"
            maxValues="3"
            v-model="educationInfo.relationLaws">
          </c-multi-select>
        </div>
        <div class="col-xs-12col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <c-text
            :editable="editable"
            :disabled="disabled"
            label="주요 대상자"
            name="mainTargetAudience"
            v-model="educationInfo.mainTargetAudience">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
          <c-plant 
            :required="true" 
            :editable="editable" 
            :disabled="disabled"
            type="edit" 
            name="plantCd" 
            v-model="educationInfo.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
          <c-dept
            :editable="editable"
            :required="true" 
            :disabled="disabled"
            :data="educationInfo"
            label="주관 부서"
            name="departmentDeptCd"
            v-model="educationInfo.departmentDeptCd">
          </c-dept>
        </div>
      </template>
    </c-card>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="table"
        title="교육내용"
        :columns="grid.columns"
        :gridHeight="grid.height"
        :data="educationInfo.eduSubjectList"
        :filtering="false"
        :columnSetting="false"
        :usePaging="false"
        :hideBottom="true"
        noDataLabel="교육내용이 없습니다."
        :editable="editable && !disabled"
        rowKey="subjectNo"
        selection="multiple"
      >
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn v-if="editable && !disabled" label="추가" :showLoading="false"  icon="add" @btnClicked="addItem" />
            <c-btn v-if="editable && !disabled && educationInfo.eduSubjectList.length > 0" label="제외" :showLoading="false" icon="remove" @btnClicked="removeItem" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
  <c-dialog :param="popupOptions"></c-dialog>
  </q-form>
</template>
<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'education-plan-info',
  props: {
    param: {
      type: Object,
      default: () => ({
        eduEducationId: '',
        eduCourseId: '',
        completeSt: '',
      }),
    },
    saveCall: {
      type: Object,
      default: () => ({
        saveCallData: '',
      }),
    },
  },
  data() {
    return {
      editable: true,
      educationInfo: {
        eduEducationId: '',
        eduEducationYearPlanId: '',
        educationName: '',
        eduCourseId: '',
        plantCd: '',
        educationYear: '',
        educationCourseName: '',
        educationKindCdLarge: null,
        educationKindCdSmall: null,
        educationTypeCd: null,
        departmentDeptCd: '',
        legalEducationFlag: null,
        educationTime: '',
        educationCycle: null,
        educationPurpose: '',
        relationLaws: '',
        mainTargetAudience: '',
        educationMonth: null,
        educationLocation: '',
        estimatedEducationExpenses: '',
        executionBudget: '',
        educationStartDate: '',
        educationEndDate: '',
        educationStartTime: '',
        educationEndTime: '',
        instructorInformation: '',
        sopMocId: '',
        educationMethodCd: null,
        sumEducationTime: '',
        educationOverview: '',
        evaluationEvalCd: '',
        documentStatusCd: '',
        educationRangeFlag: 'Y',
        qrCodeRoute: '',
        checkAppr: '',
        regUserId: '',
        oriUserId: '',
        chgUserId: '',
        eduSubjectList: [], // 과정별 교육과목
        deleteEduSubjectList: [],
        eduAttendeeList: [],
      },
      sumEducationTime: '',
      flagItems: [
        { code: 'Y', codeName: '해당' },
        { code: 'N', codeName: '해당없음' },
      ],
      grid: {
        columns: [
          {
            name: 'subjectName',
            field: 'subjectName',
            label: '과목 및 세부내용',
            align: 'left',
            style: 'width:50%',
            type: 'text',
            sortable: false,
          },
          // {
          //   name: 'subjectDetailName',
          //   field: 'subjectDetailName',
          //   label: '세부내용',
          //   style: 'width:100px',
          //   align: 'left',
          //   type: 'text',
          //   sortable: false,
          // },
          {
            name: 'educationTime',
            field: 'educationTime',
            label: '교육시간',
            type: 'datetime',
            style: 'width:20%',
            align: 'center',
            sortable: false
          },
          {
            name: 'instructorName',
            field: 'instructorName',
            type: 'text',
            label: '강사명',
            style: 'width:30%',
            align: 'left',
            sortable: false
          },
        ],
        height: '300px'
      },
      title: '',
      
      selectDate: '',
      isOpen: false,
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      saveUrl: 'transactionConfig.sop.edu.plan.insert.url',
      saveType: 'POST',
      isSave: false,
      getUrl: '',
      insertUrl: '',
      deleteUrl: '',
      updateUrl: '',
      completeUrl: '',
      updateMode: false,
      educationDate2: '',
      newDate: ['', ''],
      newTime: ['', ''],
    };
  },
  computed: {
    disabled() {
      return Boolean(this.educationInfo.documentStatusCd) && this.educationInfo.documentStatusCd === 'ESC000010'
    },
    yearEduAppr() {
      // 연간교육계획이 결재중인지 여부 체크
      return this.educationInfo.checkAppr === 'ASC0000001'
    },
    isDate() {
      return this.educationInfo.educationRangeFlag === 'Y'
    },
    educationDate: {
      get() {
        if (this.educationInfo.educationStartDate && this.educationInfo.educationEndDate) {
          return [this.educationInfo.educationStartDate, this.educationInfo.educationEndDate]
        } else {
          return this.newDate;
        }
      },
      set(newDate) {
        if (newDate && newDate.length > 0) {
          this.educationDate[0] = newDate[0]
          this.educationDate[1] = newDate[1]
        } 
        this.newDate = newDate;
      }
    },
    // educationDate2: {
    //   get() {
    //     if (this.educationInfo.educationStartDate && this.educationInfo.educationEndDate) {
    //       return this.educationInfo.educationStartDate
    //     } else {
    //       return this.newDate;
    //     }
    //   },
    //   set(newDate) {
    //     if (newDate && this.educationDate2 !== newDate) {
    //       console.log('educationDate2', this.educationDate2)
    //       console.log('newDate2', newDate)
    //       this.educationDate2 = newDate
    //     } 
    //     this.newDate = newDate;
    //   }
    // },
    educationTime: {
      get() {
        if (this.educationInfo.educationStartTime && this.educationInfo.educationEndTime) {
          return [this.educationInfo.educationStartTime, this.educationInfo.educationEndTime]
        } else {
          return this.newTime;
        }
      },
      set(newTime) {
        if (newTime && newTime.length > 0) {
          this.educationInfo.educationStartTime = newTime[0]
          this.educationInfo.educationEndTime = newTime[1]
        }
        this.newTime = newTime;
      }
    }
  },
  /* eslint-disable no-unused-vars */
  watch: {
    'educationInfo'() {
      this.$emit('transInfo', this.educationInfo);
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
    this.init();
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      if (this.param.educationKindCdLarge) {
        this.educationInfo.educationKindCdLarge = this.param.educationKindCdLarge;
      }
      this.getUrl = selectConfig.sop.edu.result.get.url;
      this.insertUrl = transactionConfig.sop.edu.plan.insert.url;
      this.updateUrl = transactionConfig.sop.edu.plan.update.url;
      this.completeUrl = transactionConfig.sop.edu.annual.complete.url;
      // list setting
      this.getDetail();
    },
    getDetail() {
      if (this.param.eduEducationId) {
        this.$http.url = this.$format(this.getUrl, this.param.eduEducationId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.educationInfo = _result.data;

          if (this.educationInfo.educationRangeFlag !== 'Y') {
            this.educationDate2 = this.educationInfo.educationStartDate
          }
          // this.sumEduTime();
          this.updateMode = true;
        },);
      }
      // 교육과정에서 신규 계획등록 시
      if (this.param.eduCourseId) {
        this.$http.url = this.$format(selectConfig.sop.edu.course.get.url, this.param.eduCourseId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          // 빈값들 filter
          this.educationInfo.educationName = _result.data.educationCourseName, // 교육과정명
          this.educationInfo.educationCourseName = _result.data.educationCourseName, // 교육과정명
          this.educationInfo.educationTypeCd = _result.data.educationTypeCd, // 교육구분
          // 교육과정 마스터 데이터 
          this.educationInfo.eduCourseId = _result.data.eduCourseId, // 교육과정 key
          this.educationInfo.educationCycle = _result.data.educationCycle, // 교육주기
          this.educationInfo.educationKindCdLarge = _result.data.educationKindCdLarge, // 교육종류 대
          this.educationInfo.educationKindCdSmall = _result.data.educationKindCdSmall, // 교육종류 소
          this.educationInfo.educationPurpose = _result.data.educationPurpose, // 학습목적
          this.educationInfo.legalEducationFlag = _result.data.legalEducationFlag, // 법정여부
          this.educationInfo.mainTargetAudience = _result.data.mainTargetAudience, // 주요대상자
          this.educationInfo.relationLaws = _result.data.relationLaws, // 관련법규
          this.educationInfo.educationTime = _result.data.educationTime // 교육시간
          this.educationInfo.estimatedEducationExpenses = _result.data.estimatedEducationExpenses // 교육시간
          this.educationInfo.eduSubjectList = _result.data.eduCourseSubjectList;
          this.educationInfo.plantCd = _result.data.plantCd;

          this.$_.forEach(this.educationInfo.eduSubjectList, _item => {
            _item.editFlag = 'C'
          })
        },);
      }
    },
    sumEduTime(props, col) {
      let hours = 0;
      let minutes = 0;
      this.$_.forEach(this.educationInfo.eduSubjectList, _item => {
        if (_item.educationTime) {
          let timeArray = _item.educationTime.split(":");
          hours += Number(timeArray[0])
          minutes +=Number(timeArray[1])
        }
      })
      if (minutes >= 60) {
        hours += Number(parseInt(minutes / 60))
        minutes = Number(minutes % 60)
      }
      this.educationInfo.sumEducationTime = hours + '시간 ' + minutes + '분 ';
    },
    eduTimeChange() {
      /**
       * 2023-03-08 kdh
       * 
       * 교육일 비교
       * 
       *  1. 기간/일 체크
       */
      let diffDays = 0;
      if (this.educationInfo.educationRangeFlag === 'Y') {
        // 기간
        if (this.educationDate && this.educationDate.length > 0 && this.educationDate[0]) {
          let startDay = this.$comm.moment(this.educationDate[0])
          let endDay = this.$comm.moment(this.educationDate[1])
          diffDays = this.$comm.moment.duration(endDay.diff(startDay)).asDays() + 1
        }
      } else {
        // 일
        diffDays = 1;
      }
      /**
       * 시간 비교
       * 
       *  1. 유효성 체크
       *   - 시간(from, to)가 존재하는지?
       *   - 존재하지 않을시에 총 교육시간을 변경하지 않음
       *  2. 시간 차이
       *  3. 포맷(시:분)에 맞게 총교육시간 표시
       */
      if (this.educationTime && this.educationTime.length === 2 && this.educationTime[0]) {
        let defaultDay = this.$comm.getToday();
        let start = this.$comm.moment(defaultDay + ' ' + this.educationTime[0])
        let end = this.$comm.moment(defaultDay + ' ' + this.educationTime[1])
        let diffMinutes = diffDays * (this.$comm.moment.duration(end.diff(start)).asMinutes())
        this.$set(this.educationInfo, 'sumEducationTime', `${parseInt(diffMinutes / 60)}:${diffMinutes % 60}`)
      }
    },
    saveEducation() {
      if (this.param.eduEducationId) {
        this.saveUrl = this.updateUrl;
        this.saveType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.saveType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.educationInfo.regUserId = this.$store.getters.user.userId
              this.educationInfo.chgUserId = this.$store.getters.user.userId
              
              if (this.educationInfo.educationRangeFlag === 'Y') {
                if (this.educationDate && this.educationDate.length > 0) {
                  this.educationInfo.educationStartDate = this.educationDate[0];
                  this.educationInfo.educationEndDate = this.educationDate[1];
                }
              } else {
                this.educationInfo.educationStartDate = this.educationDate2;
                this.educationInfo.educationEndDate = this.educationDate2;
              }

              if (this.educationTime && this.educationTime.length > 0) {
                this.educationInfo.educationStartTime = this.educationTime[0];
                this.educationInfo.educationEndTime = this.educationTime[1];
              }
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.param.eduEducationId = result.data;
      this.saveCall.saveCallData = uid();
      this.getDetail();
    },
    addItem() {
      this.educationInfo.eduSubjectList.splice(0, 0, {
        eduEducationId: this.param.eduEducationId,
        eduCourseId: this.eduCourseId,
        subjectNo: uid(),
        subjectName: '', // 교육명
        subjectDetailName: '', // 세부내용
        educationTime: '', // 교육시간
        instructorName: '', // 강사명
        editFlag: 'C',
      })
    },
    removeItem() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          this.educationInfo.eduSubjectList = this.$_.reject(this.educationInfo.eduSubjectList, item)
        })
        this.$_.forEach(selectData, item => {
          if (!this.educationInfo.deleteEduSubjectList) {
            this.educationInfo.deleteEduSubjectList = []
          }
          if (this.$_.findIndex(this.educationInfo.deleteEduSubjectList, { subjectNo: item.subjectNo }) === -1
            && item.editFlag !== 'C') {
              this.educationInfo.deleteEduSubjectList.push(item)
          }
          this.educationInfo.eduSubjectList = this.$_.reject(this.educationInfo.eduSubjectList, item)
        })
      }
    },
    searchEduMaster() {
      this.popupOptions.title = '교육과정 검색'; // 교육과정 검색
      this.popupOptions.param = {
        type: 'single',
        plantCd: this.educationInfo.plantCd,
        educationKindCdLarge: this.educationInfo.educationKindCdLarge,
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/edu/educationCurriculumnPop.vue'}`);
      this.popupOptions.width = '95%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeEduCoursePopup;
    },
    closeEduCoursePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data.selectData && data.selectData.length > 0) {
        this.$http.url = this.$format(selectConfig.sop.edu.course.get.url, data.selectData[0].eduCourseId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          // 빈값들 filter
          this.educationInfo.educationCourseName = _result.data.educationCourseName, // 교육과정명
          this.educationInfo.educationTypeCd = _result.data.educationTypeCd, // 교육구분
          // 교육과정 마스터 데이터 
          this.educationInfo.eduCourseId = _result.data.eduCourseId, // 교육과정 key
          this.educationInfo.educationCycle = _result.data.educationCycle, // 교육주기
          this.educationInfo.educationKindCdLarge = _result.data.educationKindCdLarge, // 교육종류 대
          this.educationInfo.educationKindCdSmall = _result.data.educationKindCdSmall, // 교육종류 소
          this.educationInfo.educationPurpose = _result.data.educationPurpose, // 학습목적
          this.educationInfo.legalEducationFlag = _result.data.legalEducationFlag, // 법정여부
          this.educationInfo.mainTargetAudience = _result.data.mainTargetAudience, // 주요대상자
          this.educationInfo.relationLaws = _result.data.relationLaws, // 관련법규
          this.educationInfo.educationTime = _result.data.educationTime // 교육시간
          this.educationInfo.estimatedEducationExpenses = _result.data.estimatedEducationExpenses // 교육시간
          this.educationInfo.eduSubjectList = _result.data.eduCourseSubjectList;

          this.$_.forEach(this.educationInfo.eduSubjectList, _item => {
            _item.editFlag = 'C'
          })
        },);
      }
    },
    linkClick() {
      this.popupOptions.title = '교육과정 상세'; // 교육과정 상세
      this.popupOptions.param = {};
      this.popupOptions.target = () => import(`${'@/pages/sop/edu/cc/educationCurriculumDetail.vue'}`);
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeLinkPopup;
    },
    closeLinkPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    removeEduMaster() {
      this.educationInfo = {
        eduEducationId: '',
        eduCourseId: '',
        plantCd: '',
        educationYear: '',
        educationCourseName: '',
        educationKindCdLarge: null,
        educationKindCdSmall: null,
        // educationTypeCd: null,
        departmentDeptCd: '',
        legalEducationFlag: null,
        educationTime: '',
        educationCycle: null,
        educationPurpose: '',
        relationLaws: '',
        mainTargetAudience: '',
        educationMonth: null,
        educationLocation: '',
        budgetPlan: '',
        executionBudget: '',
        educationStartDate: '',
        educationEndDate: '',
        instructorInformation: '',
        sopMocId: '',
        educationMethodCd: null,
        educationOverview: '',
        evaluationEvalCd: '',
        documentStatusCd: '',
        qrCodeRoute: '',

        eduSubjectList: [],
      }
    },
    datachange() {
      this.educationInfo.educationStartDate = '';
      this.educationInfo.educationEndDate = '';
      if (this.educationInfo.educationRangeFlag === 'Y') {
        this.educationDate2 = '';
      } else {
        this.educationDate = ['', ''];
      }
    }
  }
};
</script>
<style>
.canvas {
  width: 100%;
  height: 100%;
  margin: 3 auto;
  display: inline;
}
.wrap {
  display:flex;
  flex-wrap:wrap;
  padding:20px;
  height:400px;
  box-sizing:border-box;
  border-color: #aaa;
}
.facilityStyle {
  height:200px;
  width:300px;
  display:flex;
  align-items:center;
  justify-content:center;
  flex-wrap:wrap;
}
.abc {
  width:100%;
  height:20px;
  display:inline;
}
</style>